import { render, staticRenderFns } from "./OrganizationGroupTable.vue?vue&type=template&id=3a888976&"
import script from "./OrganizationGroupTable.vue?vue&type=script&lang=js&"
export * from "./OrganizationGroupTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports